/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/
import { Component, OnDestroy, OnInit } from '@angular/core';

import { ConfigService } from '../../core/services/config.service';
import { EditModeService } from '../../core/services/edit-mode.service';
import { HistoryOps } from '../../core/model/history-ops.model';
import { LmsBaseAppComponent } from '../../core/component/base-app/lms-base-app.component';
import { LmsLoaderService } from '../../core/services/lms-loader.service';
import { LmsMenuService } from '../../core/services/lms-menu.service';
import { LmsModuleService } from '../../core/services/lms-module.service';
import { LocoHistory } from '../../core/model/loco-history.model';
import { LocoHistoryService } from '../services/loco-history.service';
import { PopupService } from '../../core/services/popup.service';
import { RouteChangePopupService } from '../../core/services/route-change-popup.service';
import { TabSearchParameter } from '../../core/model/tab-search-parameter.model';
import { UtilService } from '../../core/services/util.service';
import { PermitAll } from '@csx/security';

@Component({
  selector: 'lms-loco-history',
  templateUrl: './loco-history.component.html',
  styleUrls: ['./loco-history.component.scss']
})
@PermitAll()
export class LmsLocoHistoryComponent extends LmsBaseAppComponent implements OnInit, OnDestroy {

  historyOps: HistoryOps;
  history: Array<LocoHistory>;

  /**
   * Creates an instance of LmsLocoHistoryComponent.
   * @param {LocoHistoryService} locoHistoryService
   * @param {ConfigService} configService
   * @param {LmsMenuService} lmsMenuService
   * @param {LmsModuleService} lmsModuleService
   * @param {UtilService} utilService
   * @param {EditModeService} editModeService
   * @param {RouteChangePopupService} routerChangePopUpService
   * @param {PopupService} popupService
   * @param {LmsLoaderService} lmsLoaderService
   *
   * @memberOf LmsLocoHistoryComponent
   */
  constructor(private locoHistoryService: LocoHistoryService, configService: ConfigService,
    lmsMenuService: LmsMenuService,
    lmsModuleService: LmsModuleService,
    utilService: UtilService,
    editModeService: EditModeService,
    routerChangePopUpService: RouteChangePopupService,
    popupService: PopupService,
    private lmsLoaderService: LmsLoaderService) {
    super(configService, lmsMenuService, lmsModuleService, utilService, editModeService, routerChangePopUpService, popupService);
    this.service = this.locoHistoryService;
    this.type = this.configService.getConfigData().menu.type.locomotive;
    this.historyOps = {};
    this.history = [];
  }

  /**
   * this is the life cycle method od this component
   * and called on initialization of this component
   * @memberOf LmsLocoHistoryComponent
   */
  ngOnInit() {
    this.lmsLoaderService.hideLoader();
    super.init(this.search);
    if (this.selectedTab && this.selectedTab.tabSearchParameter) {
      if (this.selectedTab.tabSearchParameter.displayType && this.selectedTab.tabSearchParameter.spinnerVal) {
        this.historyOps.days = this.selectedTab.tabSearchParameter.spinnerVal;
        this.historyOps.displayType = this.selectedTab.tabSearchParameter.displayType;
      } else {
        this.historyOps.days = 2;
        this.historyOps.displayType = ' ';
        this.selectedTab.tabSearchParameter.displayType = ' ';
        this.selectedTab.tabSearchParameter.spinnerVal = 2;
        this.lmsModuleService.updateSelectedTab(this.selectedTab);
      }
    }
  }

  /**
   * this method is used to trigger the search
   * @memberOf LmsLocoHistoryComponent
   */
  public search() {
    if (this.selectedTab.tabSearchParameter.searchText) {
      this.locoHistoryService.load(this.selectedTab, this.historyOps);
    }
  }

  /**
   * this method is used to catch the value change event
   * triggered by the child and update the changed values to
   * selected tab and trigger search operation
   * @param {any} event
   * @memberOf LmsLocoHistoryComponent
   */
  public historyTypeValueChangeListner(event) {
    this.historyOps = event;
    if (this.selectedTab && this.selectedTab.tabSearchParameter) {
      this.selectedTab.tabSearchParameter.displayType = event.displayType;
      this.selectedTab.tabSearchParameter.spinnerVal = event.days;
    } else {
      const tabSearchParam = <TabSearchParameter>{
        spinnerVal: event.days,
        displayType: event.displayType
      };
      this.selectedTab.tabSearchParameter = tabSearchParam;
    }
    if (this.selectedTab && this.selectedTab.tabSearchParameter && this.selectedTab.tabSearchParameter.searchText) {
      this.selectedTab.subTypeDetail[this.selectedTab.subType.toLowerCase()].status = 'refresh';
    }
    this.lmsModuleService.updateSelectedTab(this.selectedTab);
    this.search();
  }

  /**
   * this mehtod is used to clear
   * the tab level error messages
   * @param {any} event
   * @memberOf LmsLocoHistoryComponent
   */
  public clearErrorMessage(event) {
    this.selectedTab.subTypeDetail.history.message = '';
    this.lmsModuleService.updateSelectedTab(this.selectedTab);
  }

  /**
   * this is the life cycle method of this component
   * and will be called on destroy of this component
   * @memberOf LmsLocoHistoryComponent
   */
  ngOnDestroy() {
    super.destroy();
  }

}
